"use client";
// Imports
import { Container, ComponentWrapper } from "@/components";
import { cn } from "@/lib/utils";

const SPACING_TOP = {
  none: "pt-0",
  small: "pt-3 lg:pt-4",
  medium: "pt-6 lg:pt-10",
  large: "pt-10 lg:pt-16",
  extra_large: "pt-16 lg:pt-24",
};

const SPACING_BOTTOM = {
  none: "pb-0",
  small: "pb-3 lg:pb-4",
  medium: "pb-6 lg:pb-10",
  large: "pb-10 lg:pb-16",
  extra_large: "pb-16 lg:pb-24",
};

function resolveSpacingValue(spacing) {
  if (!spacing) return "medium";
  return typeof spacing === "object" ? spacing.value : spacing;
}

// Instructions — fawn band with numbered steps (number left, content right)
export function Instructions({
  type,
  title,
  steps = [],
  spacingTop,
  spacingBottom,
}) {
  const items = steps.filter((step) => step?.title || step?.text);
  if (!items.length) return null;

  const topKey = resolveSpacingValue(spacingTop);
  const bottomKey = resolveSpacingValue(spacingBottom);

  return (
    <ComponentWrapper
      type={type}
      className={cn(
        SPACING_TOP[topKey] ?? SPACING_TOP.medium,
        SPACING_BOTTOM[bottomKey] ?? SPACING_BOTTOM.medium
      )}
    >
      <div className="w-full bg-brand-fawn text-brand-wool">
        <Container>
          <div className="py-10 sm:py-12 lg:py-16">
            {title && (
              <h2 className="font-heading font-heading-sentence text-brand-wool text-xl sm:text-3xl lg:text-[2.5rem] leading-none mb-8 lg:mb-10">
                {title}
              </h2>
            )}

            <ol className="flex flex-col gap-6 lg:gap-8 list-none m-0 p-0">
              {items.map((step, index) => (
                <li
                  key={step?.id ?? index}
                  className="flex items-center gap-4 lg:gap-5"
                >
                  <div
                    className={cn(
                      "shrink-0 flex items-center justify-center rounded-full",
                      "bg-brand-red-gum text-brand-wool",
                      // ~step text block height on desktop; slightly smaller on mobile
                      "size-[4.25rem] text-xl sm:size-[4.75rem] sm:text-2xl lg:size-[5.0625rem] lg:text-[1.75rem]",
                      "leading-none select-none"
                    )}
                    aria-hidden
                  >
                    {/* Keep font-heading outside twMerge — it conflicts with font-heading-sentence */}
                    <span className="font-heading font-heading-sentence font-bold">
                      {index + 1}.
                    </span>
                  </div>
                  <div className="min-w-0 flex-1">
                    {step?.title && (
                      <h2 className="font-heading font-heading-sentence text-brand-wool text-xl sm:text-3xl lg:text-[2.5rem] leading-none">
                        {step.title}
                      </h2>
                    )}
                    {step?.text && (
                      <p className="font-body text-brand-wool/85 text-base lg:text-lg leading-snug mt-1.5 sm:mt-2 text-pretty">
                        {step.text}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </Container>
      </div>
    </ComponentWrapper>
  );
}
